import {pageInfo, details, agree, selectByPlantCodeAndVehicleNo, selectWeighValue, createWeighRecord, exportData, print, selectPurchOrder} from '../api';
import {weighType, reshipSku, device, vehicleType, fuzzyQueryStorage, plant} from '../../../../api'

const manualWeigh = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    collectionObj: null,
    detailsObj: null,
    agreeObj: null,
    refuseObj: null,
    weighTypeObj: null,
    reshipSkuObj: null,
    deviceObj: null,
    vehicleTypeObj: null,
    andvehiclenoObj: null,
    storageObj: null,
    createWeighRecordObj: null,
    selectWeighObj: null,
    printObj: null,
    exportObj: null,
    purchOrderObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    DEAILS(state, data) {
      state.detailsObj = data;
    },
    AGREE(state, data) {
      state.agreeObj = data;
    },
    REFUSE(state, data) {
      state.refuseObj = data;
    },
    WEIGH_TYPE_DATA(state, data) {
      state.weighTypeObj = data;
    },
    RESHIP_SKU_DATA(state, data) {
      state.reshipSkuObj = data;
    },
    DEVICE_DATA(state, data) {
      state.deviceObj = data;
    },
    VEHICLE_TYPE_DATA(state, data) {
      state.vehicleTypeObj = data;
    },
    STORAGE_DATA(state, data) {
      state.storageObj = data;
    },
    SELECT_BY_PLANTCODE_ANDVEHICLENO_DATA(state, data) {
      state.andvehiclenoObj = data;
    },
    CREATE_WEIGH_RECORD_DATA(state, data) {
      state.createWeighRecordObj = data;
    },
    SELECT_WEIGH_DATA(state, data) {
      state.selectWeighObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PRINT_DATA(state, data) {
      state.printObj = data;
    },
    SELECT_PURCH_ORDER_DATA(state, data) {
      state.purchOrderObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async details({commit}, obj) {
      let resp = await details(obj);
      commit('DEAILS', resp);
    },
    async agree({commit}, obj) {
      let resp = await agree(obj);
      commit('AGREE', resp);
    },
    //称重类型
    async weighType({commit}, obj) {
      let resp = await weighType(obj);
      commit('WEIGH_TYPE_DATA', resp);
    },
    //货物类型模糊搜索-物料
    async reshipSku({commit}, obj) {
      let resp = await reshipSku(obj);
      commit('RESHIP_SKU_DATA', resp);
    },
    //地磅类型
    async device({commit}, obj) {
      let resp = await device(obj);
      commit('DEVICE_DATA', resp);
    },
    //车辆类型
    async vehicleType({commit}, obj) {
      let resp = await vehicleType(obj);
      commit('VEHICLE_TYPE_DATA', resp);
    },
    //库位模糊搜索
    async fuzzyQueryStorage({commit}, obj) {
      let resp = await fuzzyQueryStorage(obj);
      commit('STORAGE_DATA', resp);
    },
    //创建手工称重
    async createWeighRecord({commit}, obj) {
      let resp = await createWeighRecord(obj);
      commit('CREATE_WEIGH_RECORD_DATA', resp);
    },
    //基地
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    //查询称重结果
    async selectWeighValue({commit}, obj) {
      let resp = await selectWeighValue(obj);
      commit('SELECT_WEIGH_DATA', resp);
    },
    //查询未完成的手工称重订单
    async selectByPlantCodeAndVehicleNo({commit}, obj) {
      let resp = await selectByPlantCodeAndVehicleNo(obj);
      commit('SELECT_BY_PLANTCODE_ANDVEHICLENO_DATA', resp);
    },
    //查询根据采购单查询带出供应商数据
    async selectPurchOrder({commit}, obj) {
      let resp = await selectPurchOrder(obj);
      commit('SELECT_PURCH_ORDER_DATA', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async print({ commit }, obj) {
      let resp = await print(obj);
      commit('PRINT_DATA', resp);
    },
  }
}
export default manualWeigh



// WEBPACK FOOTER //
// ./src/page/bd/manualWeighDelivery/store/manualWeighDelivery.store.js